const tryParseJSONObject = (jsonString) => {
  try {
    const o = JSON.parse(jsonString)

    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) {}

  return {}
}
export function getSearchParams(searchStr) {
  const search = searchStr || window.location.search
  if (!search.length) {
    return {}
  }
  const decodedString = `{"${decodeURI(search.substring(1))
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')}"}`
  return tryParseJSONObject(decodedString)
}

export function getStatusFilter(filterStr = '') {
  const filtersMap = {
    c: 'completed',
    f: 'failed',
    h: 'hold',
    n: 'new',
    p: 'post_processing',
    r: 'restarted',
  }

  return filterStr.split(',').map((filterLetter) => filtersMap[filterLetter])
}

export const addToSearch = (search = '', term, index) => {
  if (search === '' || index === 0) {
    search += '?'
  } else {
    search += '&'
  }
  return search + term
}

export const getActivePage = (location) => {
  if (location && location.search.indexOf('page=') !== -1) {
    return parseInt(location.search.split('page=').pop(), 0)
  }
  return 1
}

export const groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {
    // eslint-disable-next-line no-param-reassign
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export const isValidGuid = (guid) => {
  const regex =
    /^(((?=.*}$){)|((?!.*}$)))((?!.*-.*)|(?=(.*[-].*){4}))[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}?[}]?$/gm
  return regex.test(guid)
}
export const isNewWindow = (event) => {
  if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
    return event.metaKey
  } else {
    return event.ctrlKey
  }
}
export const toCamelCase = (str) =>
  str
    .replace(/\s(.)/g, ($1) => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, ($1) => $1.toLowerCase())

export const buildUrl = (baseUrl, params) => {
  let url = baseUrl
  Object.keys(params).forEach((key, index) => {
    url = addToSearch(url, `${key}=${params[key]}`, index)
  })
  return url
}

export const isStaff = (user) => user && (user.is_staff || user.groups.includes('netki_staff'))

export const isIdentityUsingMinerva = (transactionIdentity) =>
  transactionIdentity &&
  transactionIdentity.identity_data_sources &&
  transactionIdentity.identity_data_sources.some(
    (source) => source.data_provider && source.data_provider.id === parseInt(process.env.REACT_APP_MINERVA_ID)
  )

export const isBusinessUsingMinerva = (business) =>
  business &&
  business.business_data_sources &&
  business.business_data_sources.some(
    (source) => source.data_provider && source.data_provider.id === parseInt(process.env.REACT_APP_MINERVA_ID)
  )

export const isClientAdmin = (user) => {
  if (!user) {
    return false
  }
  const { groups } = user
  return !!(groups && groups.includes('client_admins'))
}

export const isClientReviewer = (user) => {
  if (!user) {
    return false
  }
  const { groups } = user
  return !!(groups && (groups.includes('client_admins') || groups.includes('managers')))
}

export const isStaffOrClientReviewer = (user, state) => {
  if (state !== 'post_processing' && state !== 'customer_review') {
    return true
  }
  if (isStaff(user) && state === 'post_processing') {
    return true
  }
  return !!(isClientReviewer(user) && state === 'customer_review')
}

export const isManualPageAvailable = (user) => (isStaff(user) ? true : isClientAdmin(user))
